import { inject, Injectable } from '@angular/core';
import { API_CONFIG, HttpService } from '@nebula-shared/data-access';
import { Observable } from 'rxjs';
import { SystemParametersDto } from '@nebula-shared/domain';

@Injectable({
  providedIn: 'root',
})
export class AnullDateRangePickerServices {
  protected http = inject(HttpService);

  setHttpService(httpService: any) {
    this.http = httpService;
  }

  getSystemDate(): Observable<SystemParametersDto> {
    const config = API_CONFIG.accounting;
    return this.http.getContent<SystemParametersDto>(
      `${config.baseUrl}${config.endpoints.parametrosSistema}/system-date`,
    );
  }

  getSystemFields(): Observable<SystemParametersDto> {
    const config = API_CONFIG.accounting;
    return this.http.getContent<SystemParametersDto>(
      `${config.baseUrl}${config.endpoints.parametrosSistema}/get`,
    );
  }
}
